import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'assetLink' })
export class AssetLinkPipe implements PipeTransform {
  transform(assetId: string, sharedLink = false): string {
    if (!assetId) {
      return '/assets';
    }
    if (sharedLink) {
      return '/sharing/variant/' + assetId;
    }
    return '/assets/detail/' + assetId + '/asset-info';
  }
}
